import LoadingSvg from '../images/loading.svg'

export const LoadingSvgImage = LoadingSvg
